<template>
  <v-navigation-drawer class="secondary-navigation"  right temporary fixed floating v-model="drawer">
    <v-toolbar class="transparent" flat>
      <v-text-field
        label="Search for currency"
        single-line
        v-model="searchString"
        />
    </v-toolbar>
    <VuePerfectScrollbar class="scroll-area">
      <v-list two-line class="py-0">
        <v-list-tile v-for="(rate, index) in realRates" :key="index" @click="SET_RATE(rate)">
          <v-list-tile-content>
            <v-list-tile-title v-text="rate.currency"></v-list-tile-title>
            <v-list-tile-sub-title>1 USD = {{rate.rate.toFixed(3)}} {{rate.currency}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </VuePerfectScrollbar>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters } from 'vuex';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    components: {
      VuePerfectScrollbar
    },
    computed: {
      ...mapGetters({
        rates: 'rates/GET_RATES',
      }),
      realRates(){
        if (this.rates) {
          let rates = this.rates;
          delete rates.id;
          delete rates.created_at;
          delete rates.updated_at;
          delete rates.base;
          delete rates.date;

          let objectArray = Object.keys(rates).map(key => {
            return {currency: key, rate: rates[key]};
          });

          if (this.searchString !== '') {
            return objectArray.filter(o => o.currency.toLowerCase().startsWith(this.searchString.toLowerCase()));
          }
          return objectArray;
        }
        return [];
      },
      drawer: {
        get() {
          return this.$store.getters['ui/GET_CURRENCY_DRAWER']
        },
        set (value) {
          this.$store.commit('ui/SET_CURRENCY_DRAWER', value);
        }
      }
    },
    data: () => ({
      searchString: ''
    }),
    methods: {
      SET_RATE (rate) {
        this.$store.commit('rates/SET_RATE', rate.currency);
        this.$store.commit('ui/SET_CURRENCY_DRAWER', false);
      }
    }
  }
</script>

<style lang="scss">
  .secondary-navigation {
    overflow: hidden;
    height: 100%;
    .scroll-area {
      width: 100%;
      height: 100%;
    }
  }
</style>
